// extracted by mini-css-extract-plugin
module.exports = {"option-name":"ProductOptions_option-name__LDtAI","option-select":"ProductOptions_option-select__LAP5g"};